import { useContext } from 'react';
import { BasicLoader } from 'components/loaders/basic-loader';
import { AppContext } from 'core/context/app.context';
import { PaymentLoader } from 'payment/payment-loader';

export const AppLoader = ({ children }: { children?: JSX.Element }) => {
  const { isLoading } = useContext(AppContext);

  return (
    <BasicLoader isLoading={isLoading} fullHeight={true} topOffset={true}>
      <PaymentLoader>{children}</PaymentLoader>
    </BasicLoader>
  );
};